<template>
  <div class="contactCountdetail">
    <div class="name">
      <span class="countName">{{ ruleForm.programName }}</span>
    </div>
    <div class="row-one">
      <i class="icon icon-warning"></i>
      <span v-html="topText" class="topText"></span>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="基本配置" name="first">
        <el-button
          type="primary"
          size="small"
          class="editCount"
          v-show="!isEdit"
          @click="editCount"
        >
          编辑
        </el-button>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
        >
          <el-form-item label="程序显示名称" prop="programName">
            <el-input
              v-model="ruleForm.programName"
              :maxlength="32"
              :disabled="!isEdit"
              placeholder=""
            ></el-input>
          </el-form-item>
          <el-form-item label="是否启用" prop="isEnable">
            <el-switch
              :disabled="!isEdit"
              v-model="ruleForm.isEnable"
            ></el-switch>
          </el-form-item>
          <el-form-item label="优先级" prop="programPriority">
            <el-input-number
              :min="0" 
              :disabled="!isEdit"
              v-model="ruleForm.programPriority"
              :max="4" 
              label="描述文字"
            >
            </el-input-number>
          </el-form-item>
          <el-form-item label="类型" prop="programType">
            <el-select @change="changeProgramType" v-model="ruleForm.programType" :disabled="!isEdit" placeholder="请选择">
              <el-option
                v-for="item in programTypeOptions"
                :key="item.label"
                :label="item.value"
                :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Username属性" prop="programUserName" class="username-prompt-content">
            <el-input
              :disabled="!isEdit"
              v-model="ruleForm.programUserName"
              :maxlength="32"
              placeholder="uid"
            ></el-input>
            <span class="username-prompt">需与属性映射中的账户名对应属性保持一致</span>
          </el-form-item>
          <el-form-item label="RDN属性" prop="programRdn">
            <el-input
              :disabled="!isEdit"
              v-model="ruleForm.programRdn"
              placeholder="uid"
            ></el-input>
          </el-form-item>
          <el-form-item label="UUID 属性" prop="programUuid">
            <el-input
              :disabled="!isEdit"
              v-model="ruleForm.programUuid"
              placeholder="entryUUID"
            ></el-input>
          </el-form-item>
          <el-form-item label="LDAP ObjectClass" prop="programObject">
            <el-input
              :disabled="!isEdit"
              v-model="ruleForm.programObject"
              placeholder="inetOrgPerson, organizationalPerson"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="LDAP服务器  URL"
            class="testServer"
            prop="programTestServer"
          >
            <el-input
              :disabled="!isEdit"
              class="testServerInput"
              v-model="ruleForm.programTestServer"
              placeholder="例如：ldap://172.19.63.60:389"
            ></el-input>
            <el-button
              type="primary"
              :disabled="!isEdit"
              @click="checkServer"
              >测试链接</el-button
            >
          </el-form-item>
          <el-form-item label="Base DN" prop="programBaseDN">
            <el-input
              v-model="ruleForm.programBaseDN"
              :disabled="!isEdit"
              placeholder="inetOrgPerson, organizationalPerson"
            ></el-input>
          </el-form-item>
          <el-form-item label="User Object Filter" prop="programObjectFilter">
            <el-input
              v-model="ruleForm.programObjectFilter"
              :disabled="!isEdit"
              placeholder=""
            ></el-input>
          </el-form-item>
          <el-form-item label="安全类型" prop="safeType">
            <el-radio-group
              v-model="ruleForm.safeType"
              :disabled="!isEdit && !isFirst"
            >
              <el-radio :label="1">不需要认证</el-radio>
              <el-radio :label="0">账号+密码</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="ruleForm.safeType === 0" label="管理员DN" prop="programDn">
            <el-input
              :disabled="!isEdit"
              v-model="ruleForm.programDn"
              placeholder="例如：cn=adc"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="ruleForm.safeType === 0"
            label="密码"
            class="testServer"
            prop="testPassword"
          >
            <el-input
              type="password"
              :disabled="!isEdit"
              class="testServerInput"
              auto-complete="new-password"
              v-model="ruleForm.testPassword"
              placeholder="请输入密码"
            ></el-input>
            <el-button
              type="primary"
              :disabled="!isEdit"
              @click="checkPassword"
              >测试验证</el-button
            >
          </el-form-item>
          <el-form-item>
            <div class="footer" v-show="isEdit">
              <el-button type="primary" @click="submitForm">确 定</el-button>
              <el-button @click="handleCancel">取 消</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="属性映射" name="second">
        <AttributeMapp ref="attribute" :authRuleForm="authRuleForm" :authMapping="authMapping" :accountId="accountId" @cancel="cancel" @getUserContactInfor="getUserContactInfor"></AttributeMapp>
      </el-tab-pane>
      <el-tab-pane label="同步设置" name="three">
        <div class="syncSetBox">
          <span class="title">手动同步</span>
          <el-button
            type="primary"
            @click="dataSync('1')"
            >增量同步</el-button
          >
          <el-button
            type="primary"
             @click="dataSync('0')"
            >全量同步</el-button
          >
          <!-- <span class="full-amount" v-show="tishiInfo">全量提示</span> -->
          <!-- <span class="full-amount-title" v-show="tishiInfo"><i class="success-num">{{successNum}}</i>个账户同步成功<i class="fail-num">{{failNum}}</i>个账户同步失败</span> -->
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { validatePhone } from "@/common/utils.js"
import AttributeMapp from "@/components/userContact/attributeMapp.vue"
// import DepartAPIS from "@/apis/department.js"
import ContactAPIS from "@/apis/userContact.js"

import APIS from "@/apis/userManage.js"

export default {
  components: {
    AttributeMapp
  },
  data() {
    const checkCountName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入程序显示名称"))
      } else {
        callback()
      }
    }
    return {
      rollTimer: null,
      breadcrumb: [
        {
          label: "用户联合",
          url: "/userContact"
        },
        {
          label: "用户联合详情"
        }
      ],
      realFormInfo: null,
      realauthMapping: null,
      programName: '',
      programTypeOptions: [{
          value: 'LDAP',
          label: '0'
        }, {
          value: 'Active Directory',
          label: '1'
      }],
      topText: '用户联合配置错误会导致账户管理部分功能无法使用。请确认填写的配置信息无误后再保存。',
      activeName: "first",
      authMapping: [],
      tishiInfo: false,
      ruleForm: {
        programName: "",
        isEnable: true,
        programPriority: "",
        programType:"0",
        programUserName: "uid",
        programRdn: "uid",
        programUuid: "entryUUID",
        programObject: "inetOrgPerson, organizationalPerson",
        programTestServer: "",
        programBaseDN: "",
        programObjectFilter: "",
        safeType: 0,
        programDn: "",
        testPassword: ""
      },
      authRuleForm: {
        account: '',
        surname: '',
        name: '',
        email: '',
        phone: ''
      },
      rules: {
        programName: [
          { required: true, validator: checkCountName, trigger: ['blur', 'change'] }
        ],
        programUserName: [{ required: true, message: "请输入UserName", trigger: ['blur', 'change']}],
        programRdn: [{ required: true, message: "请输入RDN", trigger: ['blur', 'change']}],
        programUuid: [{ required: true, message: "请输入UUID", trigger: ['blur', 'change']}],
        programObject: [{ required: true, message: "请输入LDAP ObjectClass", trigger: ['blur', 'change']}],
        programBaseDN: [{ required: true, message: "请输入Base DN", trigger: ['blur', 'change'] }],
        programDn: [{ required: true, message: "请输入管理员DN", trigger: ['blur', 'change'] }],
        programTestServer: [{ required: true, message: "请输入LDAP服务器 URL", trigger: ['blur', 'change'] }],
        programObjectFilter: [{ min: 0, max: 10000, message: '长度在 0 到 10000 个字符', trigger: 'blur' }],
        testPassword: [{ required: true, message: "请输入密码", trigger: ['blur', 'change'] }],
        email: [
          { required: true, message: "请输入电子邮箱", trigger: ['blur', 'change'] },
          {
            type: "email",
            message: "请输入格式正确的邮箱地址",
            trigger: "blur"
          }
        ],
        phone: [{ validator: validatePhone, trigger: ['blur', 'change'] }]
      },
      isEdit: false,
      realmName: this.$realm,
      accountId: "",
      preParams: null, // 缓存当前的参数
      selectDepart: [],
      selectAccount: [],
      department: [],
      tableDataClient: [], // 账户已授权的应用
      tableDataAllClient: [] // 所有可授权的应用
    }
  },
  created() {
    this.accountId = this.$route.query.accountId
    this.activeName = this.$route.query.flag === "1" ? "second" : "first"
  },
  mounted() {
    if (this.accountId) {
      this.getRealmsUserInfor()
      this.getDepartments()
      /* this.getUserClients() */
    }
  },
  destroyed() {
    this.rollTimer = null
  },
  methods: {
    // 获取用户授权应用
    changeProgramType () {
      if(this.ruleForm.programType === '0'){
        this.ruleForm.programUserName = 'uid'
        this.ruleForm.programRdn = 'uid'
        this.ruleForm.programUuid = 'entryUUID'
        this.ruleForm.programObject = 'inetOrgPerson, organizationalPerson'
      } else {
        this.ruleForm.programUserName = 'cn'
        this.ruleForm.programRdn = 'cn'
        this.ruleForm.programUuid = 'objectGUID'
        this.ruleForm.programObject = 'person, organizationalPerson, user'
      }
    },
    getUserContactInfor () {
      this.getRealmsUserInfor()
      this.getDepartments()
    },
    async getUserClients() {
      let { status, data } = await APIS.getUserClients(
        this.realmName,
        this.accountId
      )
      this.tableDataClient = []
      this.tableDataAllClient = []
      if (status === 0) {
        data.forEach(item => {
          let obj = {
            id: item.id,
            clientId: item.clientId,
            clientName: item.clientName,
            role: item.roles,
            authMark: item.authMark
          }
          this.tableDataAllClient.push(obj)
          if (item.authMark) {
            this.tableDataClient.push(obj)
          }
        })
      }
    },
    checkServer () {
      this.$refs["ruleForm"].validateField("programTestServer")
      this.testServer('0')
    },
    async testServer(flag) {
      if (this.ruleForm.programTestServer === '') {
        return
      }
      let params = {
        ldapURL: this.ruleForm.programTestServer
      }
      let { status, data } = await ContactAPIS.postTestServer(this.$realm, {
        data: params
      })
      if (status === 0 && flag === '0') {
        this.$message({
          message: 'LDAP服务器 URL验证成功',
          type: 'success'
        });
        return 'success'
      }else if (flag === '1' && status === 0) {
        /* donoting */
      }else{
        this.$message.error({
          message: data
        })
        return 'error'
      }
    },
    checkPassword () {
      this.$refs["ruleForm"].validateField("testPassword")
      this.testPassword('0')
    },
    async testPassword(flag) {
      if (this.ruleForm.testPassword === "") {
        return
      }
      let params = {
        ldapURL: this.ruleForm.programTestServer,
        managerDN: this.ruleForm.programDn,
        secret: this.ruleForm.testPassword
      }
      let { status, data } = await ContactAPIS.postTestPassword(this.$realm, {
        data: params
      })
      if (status === 0 && flag === '0') {
        this.$message({
          message: '密码验证成功',
          type: 'success'
        });
        return 'success'
      }else if (flag === '1' && status === 0) {
        /* donoting */
      }else{
        this.$message.error({
          message: data
        })
        return 'error'
      }
    },
    async dataSync (action) {
      let { status, data } = await ContactAPIS.postSyncUserContact(
        this.realmName,
        this.accountId,
        action
      )
      if(status === 0){
        this.tishiInfo = true
        let info = `${data.added}个账户同步成功,${data.failed}个账户同步失败,${data.updated}个账户更新`
        this.$message({
          message: info,
          type: 'success'
        });
      }
    },
    // 获取部门列表
    async getDepartments() {
      let { status, data } = await ContactAPIS.getUserContactAttribute(
        this.realmName,
        this.accountId
      )
      if (status === 0) {
        this.authMapping = data
        this.realauthMapping = data
        this.assignmentAuthMapp(data)
        /* authRuleForm */
      }
    },
    assignmentAuthMapp (data) {
      data.forEach(item => {
          if(item.name === '账户名'){
            this.authRuleForm.account = item.ldapAtt
          } else if(item.name === '邮箱') {
            this.authRuleForm.email = item.ldapAtt
          } else if(item.name === '姓') {
            this.authRuleForm.surname = item.ldapAtt
          } else if(item.name === '名') {
            this.authRuleForm.name = item.ldapAtt
          } else {
            this.authRuleForm.phone = item.ldapAtt
          }
      });
    },
    assignmentUserInfor (data) {
      this.programName.length === 0 ? this.programName = data.name : ''
      this.ruleForm.programName =  data && data.name
      this.ruleForm.isEnable= data && data.enabled === 'true' ? true : false
      this.ruleForm.programPriority= data && parseInt(data.priority)
      this.ruleForm.programType= data && data.type
      this.ruleForm.programUserName = data && data.usernameAttribute
      this.ruleForm.programRdn= data && data.rdnAttribute
      this.ruleForm.programUuid= data && data.uuidAttribute
      this.ruleForm.programObject= data && data.ldapObjectClass
      this.ruleForm.programTestServer= data && data.ldapURL
      this.ruleForm.programBaseDN= data && data.baseDN
      this.ruleForm.programObjectFilter= (data && data.userObjectFilter) || ""
      this.ruleForm.safeType= data && parseInt(data.authenticationType)
      this.ruleForm.programDn= data && data.managerDN
      this.ruleForm.testPassword='12345678'
    },
    // 获取账户信息详情
    async getRealmsUserInfor() {
      let { status, data } = await ContactAPIS.getRealmsUserContactById(
        this.realmName,
        this.accountId
      )
      if (status === 0) {
        this.realFormInfo = data
        this.assignmentUserInfor(data)
      }
    },
    // 更新账户信息
    async putAccountInfor() {
      let params = {
        ldapURL: this.ruleForm.programTestServer,
        managerDN: this.ruleForm.programDn,
        secret: this.ruleForm.testPassword,
        name: this.ruleForm.programName,
        enabled: this.ruleForm.isEnable,
        priority: this.ruleForm.programPriority,
        type: this.ruleForm.programType,
        usernameAttribute:this.ruleForm.programUserName,
        rdnAttribute:this.ruleForm.programRdn,
        uuidAttribute:this.ruleForm.programUuid,
        ldapObjectClass: this.ruleForm.programObject,
        baseDN: this.ruleForm.programBaseDN,
        userObjectFilter: this.ruleForm.programObjectFilter,
        authenticationType: this.ruleForm.safeType
      }
      let { status } = await ContactAPIS.putRealmsUserContact(
        this.realmName,
        this.accountId,
        { data: params }
      )
      if (status === 0) {
        this.isEdit = false
        // 如果部门变化，需要更新账户的授权信息，因为账户的授权会继承于部门的。还需要更新账户信息，因为部门特殊
        if (
          JSON.stringify(this.selectDepart) !==
          JSON.stringify(JSON.parse(this.preParams).department)
        ) {
          this.getRealmsUserInfor()
        }
      }
    },
    // 编辑账户按钮
    editCount() {
      this.ruleForm.testPassword = ''
      this.preParams = JSON.stringify({
        ruleForm: this.ruleForm
      })
      this.isEdit = true
    },
    // tab切换
    handleClick() {
      this.assignmentUserInfor(this.realFormInfo)
      this.assignmentAuthMapp(this.realauthMapping)
      this.isEdit = false
      this.$refs.attribute.handleCancel()
    },
    // 提交编辑表单
    async submitForm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          // 如果账户信息未改变，则不需要更新账户信息
          this.programName = this.ruleForm.programName
          if (
            this.preParams ===
            JSON.stringify({
              ruleForm: this.ruleForm
            })
          ) {
            this.isEdit = false
            return false
          }
          this.putAccountInfor()
        } else {
          this.rollTimer = setTimeout(()=>{
            var isError= document.getElementsByClassName("is-error");
            isError[0].querySelector('input').focus();
          },100);
          return false;
        }
      })
    },
    // 取消编辑账户详情信息
    handleCancel() {
      this.ruleForm.testPassword = '12345678'
      this.isEdit = false
      this.$refs["ruleForm"].resetFields()
      this.$refs.attribute.handleCancel()
      this.assignmentUserInfor(this.realFormInfo)
      this.ruleForm = Object.assign({}, JSON.parse(this.realFormInfo).ruleForm)
      this.selectDepart = Object.assign(
        {},
        JSON.parse(this.preParams).department
      )
    },
    cancel () {
      this.assignmentAuthMapp(this.realauthMapping)
    }
  }
}
</script>

<style lang="scss">
.contactCountdetail {
  .username-prompt{
    color:#454647;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 85%;
    left: 0;
  }
  .username-prompt-content{
    margin-bottom:25px;
    .el-form-item__error{
      margin-top: 10px;
    }
  }
  .row-one {
    background-color: rgba(0, 112, 204, 0.05);
    height: 50px;
    padding: 0 15px;
    font-size: 14px;
    display: flex;
    align-items: center;
    margin:0 0 25px 0;
    color: #333333;
    .reUpload {
      color: #4497ec;
    }
    .icon-warning {
      margin-right: 8px;
    }
    .topText {
      i {
        font-style: normal;
        color: #4497ec;
        &.error {
          color: #d9001b;
        }
      }
    }
  }
  .name {
    margin-bottom: 16px;
  }
  .el-form{
    width: 600px;
  }
  .el-form-item__error {
    white-space: nowrap;
  }
  .testServer{
    .el-button{
      position: absolute;
      top: 5px;
      right: 0;
    }
  }
  .syncSetBox{
    margin-top:30px;
    font-size: 14px;
    .title,.full-amount{
      margin:0 30px;
    }
    .full-amount-title{
      i{
        font-style: normal;
        margin: 0 5px;
      }
      .success-num{
        color:#5cb87a;
      }
      .fail-num {
        color:#f56c6c
      }
    }
  }
  .el-form-item__content {
    .testTip {
      color: #999;
      font-size: 13px;
      margin-left: 20px;
      vertical-align: middle;
    }
    .el-button--text {
      position: absolute;
      margin-left: 14px;
      top: 6px;
    }
    .testServerInput{
      width: 350px;
      margin-right: 9px;
    }
    .el-select{
      width: 100%;
    }
    .el-input-number{
      width: 100px;
    }
  }
  .el-tabs {
    .el-button.editCount {
      margin-bottom: 15px;
    }
    .authTip {
      display: flex;
      background-color: rgba(0, 112, 204, 0.05);
      font-size: 13px;
      color: #454647;
      padding: 10px;
      line-height: 22px;
      margin-bottom: 15px;
      align-items: center;
      i {
        margin-right: 10px;
        margin-left: 5px;
      }
    }
  }
  .el-dialog {
    &__title {
      color: #333333;
      font-weight: 600;
    }
    &__body {
      // padding: 0 50px;
      .deleteText {
        text-align: center;
        height: 50px;
        line-height: 50px;
      }
    }
  }
}
</style>
